export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-accent-500/3 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-primary-500/3 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="w-full lg:w-[42%] flex flex-col items-start gap-5 z-10">
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 bg-accent-500/15 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap">
              <i className="ri-fire-fill text-xs"></i>
              全网首发 · 实锤吃瓜
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[44px] font-extrabold text-foreground-50 leading-[1.15] tracking-tight">
              51爆料网
              <br />
              <span className="font-heading italic text-accent-400">全网热门吃瓜资讯</span>
              <br />
              <span className="text-foreground-100">与黑料视频合集</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-400 leading-relaxed max-w-lg">
              每日追踪娱乐圈最新动态，深度挖掘明星黑料与网红内幕。覆盖八卦实锤、社会事件、热点追踪等多维度资讯，高清视频一手掌握。我们以最快速度同步全网爆料，为吃瓜群众打造最全最真的爆料阵地。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 text-xs text-foreground-500">
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                每日同步更新
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                高清在线播放
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                安全匿名浏览
              </div>
            </div>

            <div className="flex items-center gap-3 pt-2">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-semibold text-sm rounded-full hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
              >
                进入爆料区
                <i className="ri-arrow-right-line text-base"></i>
              </a>
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300/30 text-foreground-200 font-medium text-sm rounded-full hover:border-accent-500/50 hover:text-accent-400 transition-all whitespace-nowrap cursor-pointer"
              >
                观看合集
                <i className="ri-play-circle-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[58%] relative">
            <div className="relative rounded-2xl overflow-hidden aspect-[16/10] lg:aspect-[16/9] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20editorial%20scene%20with%20glowing%20neon%20green%20accents%20on%20a%20black%20backdrop%2C%20abstract%20eye%20motif%20with%20digital%20circuit%20patterns%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20luxury%20dark%20aesthetic%2C%20high%20contrast%2C%20mysterious%20and%20premium%20atmosphere%2C%20minimal%20composition%20with%20strong%20focal%20point&width=1200&height=675&seq=hero-main-visual-001&orientation=landscape"
                alt="51爆料网 - 全网热门吃瓜资讯与黑料视频合集主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50/60 via-transparent to-transparent lg:from-background-50/40"></div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/80 to-transparent h-1/3 hidden lg:block"></div>
            </div>

            <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 bg-background-100/95 backdrop-blur-xl border border-background-200/50 rounded-xl px-4 py-3 hidden md:flex items-center gap-3">
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-xs text-foreground-300 whitespace-nowrap">实时爆料中</span>
              </div>
              <span className="w-px h-4 bg-background-300"></span>
              <span className="text-xs text-accent-400 font-semibold whitespace-nowrap">12,847 条更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}